import { useBlockProps } from '@wordpress/block-editor';

const View = ({ attributes }) => {
    const {
        card_title,
        card_text,
        container_css_class,
        background_color,
        border_color,
        title_color,
        text_color,
    } = attributes;

    return (
        <div
            className={container_css_class}
            style={{ backgroundColor: background_color, border: `2px solid ${border_color}` }}
        >
            <div {...useBlockProps()}>
                <h2 style={{ color: title_color }}>{card_title}</h2>
                <p style={{ color: text_color }}>{card_text}</p>
            </div>
        </div>
    );
};

export default View;
